import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { EnergyLabel } from '@cfp/shared/energy-label';
import { CurrencyModule, Icon } from '@cfp/ui';
import { TranslateModule } from '@ngx-translate/core';
import {
  PortfolioBuildingsRoadmapBuildingDTO,
  PortfolioBuildingsRoadmapBuildingDTORoadmapPlannedMeasures,
  PortfolioBuildingsRoadmapBuildingDTORoadmapYears,
  PortfolioBuildingsRoadmapDTO
} from 'csr-asset-app';

@Component({
  selector: 'cfp-report-building-roadmap-table',
  templateUrl: 'report-building-roadmap-table.html',
  styleUrls: ['../shared-styling/report-building-measure-table.scss'],
  imports: [EnergyLabel, CurrencyModule, TranslateModule, Icon],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportBuildingRoadmapTable {
  public readonly plannedMeasures = input.required<PortfolioBuildingsRoadmapBuildingDTORoadmapPlannedMeasures[]>();
  public readonly building = input.required<PortfolioBuildingsRoadmapBuildingDTO>();
  public readonly portfolioBuildingsRoadmap = input.required<PortfolioBuildingsRoadmapDTO>();
  public readonly totalInvestments = input<number[] | undefined>();
  public readonly translationKeyPrefix = input('portfolioBuildingsRoadmapReport');

  protected readonly years = computed(() => {
    const buildingRoadmap = this.building()?.roadmap;
    if (!buildingRoadmap) {
      return [];
    }
    const portfolioBuildingsRoadmap = this.portfolioBuildingsRoadmap();
    return portfolioBuildingsRoadmap.totalInvestmentPerYear.map((portfolioBuildingsRoadmap) => {
      const roadmapYear: Partial<PortfolioBuildingsRoadmapBuildingDTORoadmapYears> = buildingRoadmap.years.find(
        (roadmapYear) => roadmapYear.year === portfolioBuildingsRoadmap.year
      ) || {
        year: portfolioBuildingsRoadmap.year
      };
      return roadmapYear;
    });
  });

  protected translationKey(suffix: string): string {
    return `${this.translationKeyPrefix()}.${suffix}`;
  }
}
